import React, {Component} from "react";
import PropTypes from "prop-types";
import {connect} from "react-redux";
import classNames from "classnames";
import {orderProduct} from "../AC/order-product";
import Price from "./Price";
import Button from "@material-ui/core/Button";
import withSelectionContext from "../decorators/withSelectionContext";
import withViewPortContext from "../decorators/withViewPortContext";
import {withStyles} from "@material-ui/core/styles";
import {onPlatformSelector} from "../selectors";

const styles = () => ({
  button: {
    "backgroundColor": `#3cb868`,
    "borderRadius": `25px`,
    "height": `50px`,
    "fontWeight": `normal`,
    "padding": `0 30px`,
    "boxShadow": `none`,
    "color": `#fff`,
    "&:hover": {
      opacity: `.8`,
      backgroundColor: `#3cb868`
    }
  },
  vtb: {
    "borderRadius": `4px`,
    "backgroundColor": `#002882 !important`,
    "color": `white`,
    "&:hover": {
      backgroundColor: `#002882`
    }
  }
});

class Order extends Component {
  static propTypes = {
    orderProduct: PropTypes.func,
    classes: PropTypes.object,
    isItInViewport: PropTypes.bool,
    selected: PropTypes.object,
    onPlatform: PropTypes.string
  };

  render() {
    const {classes, isItInViewport, selected, onPlatform} = this.props;
    return (
      <div
        className={
          !isItInViewport && !selected ? `product-buttons__item_fixed` : ``
        }
      >
        <Price />
        <Button
          variant="contained"
          onClick={this.props.orderProduct}
          color="inherit"
          className={classNames(
            classes.button,
            `product-buttons__item product-buttons__item_order`,
            {[classes.vtb]: onPlatform === `vtb`}
          )}
        >
          Заказать
        </Button>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  onPlatform: onPlatformSelector(state)
});

const mapDispatchToProps = {
  orderProduct
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withStyles(styles)(withSelectionContext(withViewPortContext(Order))));
